import version from 'tailwindcss/version.js';

function getTailwindVersion() {
  try {
    return parseInt(version.split(".")[0], 10);
  } catch (_) {
    return;
  }
}

export { getTailwindVersion };
//# sourceMappingURL=get-tailwind-version.js.map
